export default __webpack_public_path__ + "static/media/logo_pln_white.0208aecd.png";